var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssociatepartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48112",
    "data-name": "Group 48112",
    transform: "translate(-19444 -4472.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1196",
    "data-name": "Ellipse 1196",
    transform: "translate(19444 4472.564)",
    fill: "none",
    stroke: "#7d31fa",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 32.5,
    ry: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 29,
    ry: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rocket",
    "data-name": "Icon awesome-rocket",
    d: "M31.13,1.177a.979.979,0,0,0-.752-.752A22.369,22.369,0,0,0,25.294,0C18.933,0,15.118,3.4,12.271,7.89H5.848A2.959,2.959,0,0,0,3.206,9.522L.16,15.612a1.479,1.479,0,0,0,1.325,2.139h6.4L6.5,19.136a1.972,1.972,0,0,0,0,2.789l3.137,3.138a1.972,1.972,0,0,0,2.79,0l1.385-1.385v6.4A1.479,1.479,0,0,0,15.946,31.4l6.084-3.044a2.953,2.953,0,0,0,1.633-2.644V19.279c4.474-2.854,7.89-6.681,7.89-13.011a21.864,21.864,0,0,0-.422-5.091Zm-7.461,9.178A2.465,2.465,0,1,1,26.135,7.89a2.465,2.465,0,0,1-2.465,2.465Z",
    transform: "translate(19459.207 4491.799)",
    fill: "#7d31fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociatepartner);
export default __webpack_public_path__ + "static/media/Associatepartner.15c5707d9dd2b32cf53516a385d533be.svg";
export { ForwardRef as ReactComponent };